module.exports = __webpack_public_path__ + "img/balloons.bd0a1189.png";